__turbopack_context__.v({
  "badgesContainer": "jnzY3q_badgesContainer",
  "favoriteButton": "jnzY3q_favoriteButton",
  "imageLinkInteractionWrapper": "jnzY3q_imageLinkInteractionWrapper",
  "imageWrapper": "jnzY3q_imageWrapper",
  "lockClosedIcon": "jnzY3q_lockClosedIcon",
  "restrictedImageWrapper": "jnzY3q_restrictedImageWrapper",
  "restrictedOverlay": "jnzY3q_restrictedOverlay",
  "restrictedOverlayCopy": "jnzY3q_restrictedOverlayCopy",
});
